<template>
  <div class="space-2">
    <p class="h3-title">【F】供应链数字化</p>
    <p class="text-bold pt-4">F1*采购管理</p>
    <p>{{info.p_g_1}}</p>
    <p>{{info.p_g_2}}</p>
    <p class="text-bold pt-4">F2*仓储物流</p>
    <p>{{info.p_g_3}}</p>
    <p>{{info.p_g_4}}</p>
    <div class="pt-4 font-heiti space-y-2">
      <div class="text-center">表 2-2-5 供应链数字化（F）应用场景等级判定</div>
      <div class="grid grid-cols-5 w-full text-center items-center border-t border-solid border-black">
        <div class="col-span-1 border-b border-solid border-black py-2">&nbsp;</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-gray-level">一级</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-yellow-level">二级</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-blue-level">三级</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-purple-level">四级</div>
        <div class="col-span-1 border-b border-solid border-black py-2">F1*采购管理</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[10].level === 1 ? 'bg-gray-level' : ''">{{info.sceneArr[10].level === 1 ? info.sceneArr[10].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[10].level === 2 ? 'bg-yellow-level' : ''">{{info.sceneArr[10].level === 2 ? info.sceneArr[10].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[10].level === 3 ? 'bg-blue-level' : ''">{{info.sceneArr[10].level === 3 ? info.sceneArr[10].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[10].level === 4 ? 'bg-purple-level' : ''">{{info.sceneArr[10].level === 4 ? info.sceneArr[10].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2">F2*仓储物流</div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[11].level === 1 ? 'bg-gray-level' : ''">{{info.sceneArr[11].level === 1 ? info.sceneArr[11].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[11].level === 2 ? 'bg-yellow-level' : ''">{{info.sceneArr[11].level === 2 ? info.sceneArr[11].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[11].level === 3 ? 'bg-blue-level' : ''">{{info.sceneArr[11].level === 3 ? info.sceneArr[11].levelName : '&nbsp;'}}</div></div>
        <div class="col-span-1 border-b border-solid border-black py-2 text-white"><div class="w-full" :class="info.sceneArr[11].level === 4 ? 'bg-purple-level' : ''">{{info.sceneArr[11].level === 4 ? info.sceneArr[11].levelName : '&nbsp;'}}</div></div>
      </div>
    </div>
  </div>
</template>

<script>

// 供应链数字化
export default {
  props: ['info']
}
</script>
